import React from "react";
import { SectionHeader } from "../Header/SectionHeader";
import { SubCard } from "../card/SubCard";
import InputField from "../input/inputField";
import { Guardian } from "../../Models/guardian.models";
import { replaceArrayElement } from "../../utils/array.utils";

interface Props {
  guardians: Guardian[];
  onAddGuardian: (updatedGuardianInfo: Guardian[]) => unknown;
  onRemoveGuardian: (updatedGuardianInfo: Guardian[]) => unknown;
  onGuardianInfoChange: (updatedGuardianInfo: Guardian[]) => unknown;
  totalGuardian: number;
}
export const GuardianInfo = ({
  guardians,
  onAddGuardian,
  onRemoveGuardian,
  onGuardianInfoChange,
  totalGuardian,
}: Props) => {
  const onGuardianNameChange = (name: string, index: number) => {
    const updatedGuardianInfo = replaceArrayElement(guardians, index, {
      ...guardians[index],
      name,
    });

    onGuardianInfoChange(updatedGuardianInfo);
  };
  const onGuardianRelationChange = (relation: string, index: number) => {
    const updatedGuardianInfo = replaceArrayElement(guardians, index, {
      ...guardians[index],
      relation,
    });

    onGuardianInfoChange(updatedGuardianInfo);
  };

  const onGuardianAddressChange = (address: string, index: number) => {
    const updatedGuardianInfo = replaceArrayElement(guardians, index, {
      ...guardians[index],
      address,
    });

    onGuardianInfoChange(updatedGuardianInfo);
  };

  const onGuardianMobileChange = (mobile: string, index: number) => {
    const updatedGuardianInfo = replaceArrayElement(guardians, index, {
      ...guardians[index],
      mobile,
    });

    onGuardianInfoChange(updatedGuardianInfo);
  };

  const _onAddGuardian = () => {
    const updatedGuardianInfo = [
      ...guardians,
      {
        name: "",
        relation: "",
        address: "",
        mobile: "",
      },
    ];

    onAddGuardian(updatedGuardianInfo);
  };

  const _onRemoveGuardian = (index: number) => {
    // Create a new array without the element at the specified index
    const updatedGuardianInfo = [
      ...guardians.slice(0, index),
      ...guardians.slice(index + 1),
    ];
    // Update the with the new array
    onRemoveGuardian(updatedGuardianInfo);
  };

  return (
    <div className="flex flex-row gap-x-10 px-2">
      <div className="flex-1">
        <SectionHeader headerText="Emergency contact if you cannot be reached." />

        <SubCard
          onAddCard={_onAddGuardian}
          onRemoveCard={_onRemoveGuardian}
          totalCard={totalGuardian}
        >
          {(index) => {
            return (
              <>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-8 pl-8 pr-8">
                  <InputField
                    value={guardians[index]?.name || ""}
                    setValue={(text) => {
                      onGuardianNameChange(text, index);
                    }}
                    label="Name"
                    name={`student-guardian-${index}-name`}
                    isRequiredFocusonValidation
                  />
                  <InputField
                    value={guardians[index]?.relation || ""}
                    setValue={(text) => {
                      onGuardianRelationChange(text, index);
                    }}
                    label="Relation"
                    name={`student-guardian-${index}-relation`}
                    isRequiredFocusonValidation
                  />
                  <InputField
                    value={guardians[index]?.address || ""}
                    setValue={(text) => {
                      onGuardianAddressChange(text, index);
                    }}
                    label="Address"
                    name={`student-guardian-${index}-address`}
                    isRequiredFocusonValidation
                  />
                  <InputField
                    value={guardians[index]?.mobile || ""}
                    setValue={(text) => {
                      onGuardianMobileChange(text, index);
                    }}
                    label="Mobile"
                    name={`student-guardian-${index}-mobile`}
                    isRequiredFocusonValidation
                  />
                </div>
              </>
            );
          }}
        </SubCard>
      </div>
    </div>
  );
};
